import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum InstallmentType {
  Ordinary = 1,
  Extraordinary = 2,
  ExtraordinaryChargeback = 3,
}
EnumDescriptions.setDescriptions(InstallmentType, [
  i18n.t('enums.ordinary'),
  i18n.t('enums.extraordinary'),
  i18n.t('enums.extraordinary_chargeback'),
]);
